import React from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

const WA_URL = "https://wa.me/917827304742?text=Hi%20Calium%2C%20I%27d%20like%20a%20free%20marketplace%20account%20audit.";

export default function WhatsAppButton() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <motion.a
      href={WA_URL}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Chat on WhatsApp"
      initial={{ opacity: 0, scale: 0.6, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 2, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-5 right-5 sm:bottom-6 sm:left-6 sm:right-auto z-50 group flex items-center gap-3 rounded-full bg-[#25D366] text-white p-3.5 sm:pl-3 sm:pr-5 sm:py-3 shadow-[0_12px_40px_-10px_rgba(37,211,102,0.7)] hover:-translate-y-1 transition-transform"
    >
      <span className="relative flex">
        <span className="absolute inset-0 rounded-full bg-white/40 animate-ping" />
        <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true" className="relative">
          <path d="M16 3C9.4 3 4 8.3 4 14.9c0 2.3.7 4.5 1.9 6.4L4 29l7.9-2.1c1.8 1 3.9 1.5 6 1.5 6.6 0 12-5.3 12-11.9S22.6 3 16 3zm0 21.6c-1.9 0-3.7-.5-5.3-1.5l-.4-.2-4.6 1.2 1.2-4.5-.3-.4c-1.1-1.7-1.7-3.6-1.7-5.6 0-5.5 4.5-9.9 10.1-9.9s10.1 4.4 10.1 9.9-4.5 10-10.1 10zm5.5-7.4c-.3-.2-1.8-.9-2.1-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-.9 1.2-.2.2-.3.2-.6.1-.3-.2-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.5-.6c.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6-.1-.2-.7-1.7-.9-2.3-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1.1 1-1.1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.2 5.2 4.5 2.6 1 3.1.8 3.7.8.6-.1 1.8-.7 2.1-1.5.3-.7.3-1.3.2-1.5-.1-.1-.3-.2-.6-.4z" />
        </svg>
      </span>
      <span className="hidden sm:inline font-body font-bold text-sm">Chat on WhatsApp</span>
    </motion.a>
  );
}
